<script setup>
  defineProps({
    image: String,
    images: Array,
  })
</script>

<template>
  <img v-if="image" :src="image">
  <img v-else-if="images && images.length > 0" :src="images[0]">
  <img v-else src="/images/noimage.gif" class="no-image">
</template>
